import { useIntercom } from "../../hooks/intercom";
import ListItem from "../../ui_atoms/ListItem";
import { useI18n } from "../../hooks/i18n-hooks";
import ScreenCard from "../ScreenCard";

export default function IntercomScreen() {
    const { presentIntercom, presentMessageComposer } = useIntercom();
    const i18n = useI18n();

    return (
        <ScreenCard>
            <ListItem
                labels={[{ text: i18n.t("screens.user.help.ask_assistance"), mode: "cta" }]}
                rightIcon="ask-assistance"
                rightActionMode="action_simple"
                useBigAvatarOrIcon
                onPress={() => void presentMessageComposer()}
            />
            <ListItem
                labels={[{ text: i18n.t("screens.user.help.see_all_articles"), mode: "cta" }]}
                rightIcon="articles"
                rightActionMode="action_simple"
                useBigAvatarOrIcon
                onPress={() => void presentIntercom()}
            />
        </ScreenCard>
    );
}
